module.exports = __webpack_public_path__ + "static/elon-musk-58c581f94af3e32f0ac0c7f206ab836b.jpg";